import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

// Type for the plan creation payload
type DeletePlanPayload = {
    id: string;
};

// Mutation function that calls the API
export const deletePlan = async (payload: DeletePlanPayload) => {
    const { id } = payload;

    try {
        const response = await Axios.delete(`/plan/${id}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

// Custom hook for deleting a plan
export const useDeletePlan = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: DeletePlanPayload) => deletePlan(payload),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ["get-all-feature-plans"] }); // Adjust query key if needed
            toast.success("Plan deleted successfully.");
            console.log({ data });
        },
        onError: (error: Error) => {
            toast.error("Unable to delete plan.", { description: error.message });
            console.error({ error });
        },
    });
};
